export interface ChangeEvent {
    type: "play" | "pause" | "ended" | "volumechange";
    element: HTMLVideoElement;
}
